import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useParams } from "react-router";
import { formReportServices } from "../../../../APIServices/formReportServices";

const InsertCompanyLogo = ({ type }) => {
  const [file, setFile] = useState();
  const [logoWidth, setLogoWidth] = useState("");
  const [logoHeight, setLogoHeight] = useState("");
  const { studyId } = useParams();

  const findReportStudyMetadataData = async () => {
    let data = await formReportServices.findReportStudyMetadataData(
      type
    );
    setFile(data?.data?.logo);
    setLogoWidth(data?.data?.width);
    setLogoHeight(data?.data?.height);
  };

  const handleImageChange = async (e) => {
    let fileData = e.target.files[0];
    if (fileData) {
      const reader = new FileReader();
      reader.onload = () => {
        setFile(reader.result);
      };
      reader.readAsDataURL(fileData);

      const formData = new FormData();
      formData.append("file", fileData);

      let result = await formReportServices.uploadReportLogo(formData);
      if (result?.statusCode === 200) {
        findReportStudyMetadataData();
      }
    }
  };

  const addUpdateReportStudyMetadata = async (e) => {
    let datas = {
      type: "logoStyle",
      width: logoWidth,
      height: logoHeight,
    };
    let data = await formReportServices.addUpdateReportStudyMetadata(datas);
    if (data?.statusCode === 200) {
      findReportStudyMetadataData();
    }
  };

  const removeLogoData = async (e) => {
    let datas = {
      studyId,
      type: "logo",
      width: "",
      height: "",
    };
    let data = await formReportServices.addUpdateReportStudyMetadata(datas);
    if (data?.statusCode === 200) {
      findReportStudyMetadataData();
    }
  };

  useEffect(() => {
    findReportStudyMetadataData();
  }, []);

  return (
    <div className="uploadLogo p-3">
      <Form.Label className="mb-1 fw-bold">Upload Your Logo</Form.Label> <br />
      <div className="hstack gap-2 mb-3">
        <button className="updateProfile">
          <input
            type="file"
            onChange={handleImageChange}
            accept=".png, .jpeg, .jpg"
          />
          <i className="fa-solid fa-upload me-2"></i>
          {!file ? "Upload" : "Change"} Logo
        </button>
        {file && (
          <>
            <Form.Group className="hstack gap-2 my-2">
              <Form.Control
                type="number"
                placeholder="Width"
                style={{ width: 90 }}
                value={logoWidth}
                onChange={(e) => setLogoWidth(e.target.value)}
              />
              x
              <Form.Control
                type="number"
                placeholder="Height"
                style={{ width: 90 }}
                value={logoHeight >= 60 ? 60 : logoHeight}
                onChange={(e) => setLogoHeight(e.target.value)}
              />
            </Form.Group>
            <button
              className="updateProfile bg-primary-subtle border-primary text-primary"
              onClick={() => addUpdateReportStudyMetadata()}
            >
              <i className="fa-solid fa-floppy-disk me-2"></i>
              Save
            </button>
            <button
              className="updateProfile bg-danger-subtle border-danger text-danger"
              onClick={() => removeLogoData()}
            >
              <i className="fa-solid fa-trash-can me-2"></i>
              Delete
            </button>
          </>
        )}
      </div>
      <div>
        {file ? (
          <img
            src={file}
            alt="Logo"
            className="rounded-1"
            style={{
              width: `${logoWidth}px`,
              height: `${logoHeight}px`,
              border: "1px dashed var(--blue)",
            }}
          />
        ) : (
          <div className="hstack uploadLogoPreview justify-content-center h-100 fontSize12">
            Click to Upload Button
          </div>
        )}
      </div>
    </div>
  );
};

export default InsertCompanyLogo;
